<div class="container" *transloco="let t">
  @if (loading) {
    <multisite-loader-globe-animation-detail [width]="100" [height]="100">
    </multisite-loader-globe-animation-detail>
  }

  @if (hub) {
    <div class="my-5">
      <div class="row">
        <div class="col-lg-8">
          <!-- OWNER -->
          <div class="editable-row">
            <p class="title">
              {{
              hub.owners.length === 1
              ? t('common.owner')
              : t('common.owners')
              }}
            </p>
            <p>{{ t('hubs.owner_role_description') }}</p>
            @if (hub?.owners.length) {
              <div class="mt-3">
                <div class="contributors">
                  @for (owner of hub.owners; track owner) {
                    <span>
                      <multisite-avatar-pill (selected)="removeRoleHolder('owners', owner.email)"
                  [removalMode]="unlockUserRole['owners']" [fallbackImageUrl]="
                'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'
              " [fallbackTranslationKey]="'social.verified_user'" [imageUrl]="owner | userAvatar" [text]="
                (owner.pre_honorific ? owner.pre_honorific + ' ' : '') +
                owner.fname +
                ' ' +
                owner.lname +
                (owner.post_honorific ? ' ' + owner.post_honorific : '')
              "></multisite-avatar-pill>
                    </span>
                  }
                  <button (click)="toggleNewRoleHolderForm('owners')" class="btn btn-pill" [disabled]="loadingRoleUpdate || !isHubOwner()">
                    <div class="icon">
                      <i class="fa-solid fa-arrows-rotate"></i>
                    </div>
                    {{
                    showNewRoleForm.owners
                    ? t('common.cancel')
                    : t('common.replace')
                    }}
                  </button>
                </div>
              </div>
            }
            @if (showNewRoleForm.owners) {
<multisite-email-input-form [labelTextTranslationKey]="
          'hubs.replace_owner_instruction'
        " (emailSubmitted)="addRoleHolder('owners', $event)" [errorTranslationKey]="error"
                [loading]="loadingRoleUpdate" ngClass="w-100">
              </multisite-email-input-form>
            }
          </div>
          <!-- End of OWNER -->
          <!-- MANAGER -->
          <div class="editable-row">
            <p class="title">
              {{
              hub.managers.length === 1
              ? t('common.manager')
              : t('common.managers')
              }}
              @if (hub?.managers.length) {
                <button class="btn btn-sm btn-primary primary-dark" (click)="toggleRoleLock('managers')"
                  >
                  @if (unlockUserRole['managers']) {
                    <span>
                      <i class="fa-solid fa-lock-open mr-2"></i>{{t('common.lock')}}
                    </span>
                  }
                  @if (!unlockUserRole['managers']) {
                    <span>
                      <i class="fa-solid fa-lock mr-2"></i>{{t('common.unlock')}}
                    </span>
                  }
                </button>
              }
            </p>
            <p>{{ t('hubs.manager_role_description') }}</p>
            @if (hub?.managers.length) {
              <div class="mt-3">
                <div class="contributors">
                  @for (manager of hub.managers; track manager) {
                    <span>
                      <multisite-avatar-pill (selected)="removeRoleHolder('managers', manager.email)" [cursorNone]="!unlockUserRole['managers']"
                    [removalMode]="unlockUserRole['managers']" [fallbackImageUrl]="
                  'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'
                " [fallbackTranslationKey]="'social.verified_user'" [imageUrl]="manager | userAvatar" [text]="
                  manager.pre_honorific ? manager.pre_honorific + ' ' : '' +
                  manager.fname +
                  ' ' +
                  manager.lname +
                  (manager.post_honorific ? ' ' + manager.post_honorific : '')
                "></multisite-avatar-pill>
                    </span>
                  }
                  <button (click)="toggleNewRoleHolderForm('managers')" class="btn btn-pill" [disabled]="loadingRoleUpdate">
                    <div class="icon">
                      <i class="fa-solid fa-plus"></i>
                    </div>
                    {{
                    showNewRoleForm.managers
                    ? t('common.cancel')
                    : t('common.new')
                    }}
                  </button>
                </div>
              </div>
            }
            @if (showNewRoleForm.managers) {
<multisite-email-input-form [labelTextTranslationKey]="
          'common.enter_person_email_address'
        " (emailSubmitted)="addRoleHolder('managers', $event)" [errorTranslationKey]="error"
                [loading]="loadingRoleUpdate" ngClass="w-100">
              </multisite-email-input-form>
            }
            @if (error && unlockUserRole['managers']) {
              <alert [type]="'warning'" [dismissible]="true">
                <span *transloco="let t">{{ t(error) }}</span>
              </alert>
            }
          </div>
          <!-- End of MANAGER -->
          <!-- CONTACT PERSON -->
          <div class="editable-row">
            <p class="title">
              {{
              hub.contact_persons.length === 1
              ? t('common.contact_person')
              : t('common.contact_persons')
              }}
              @if (hub?.contact_persons.length) {
                <button class="btn btn-sm btn-primary primary-dark" (click)="toggleRoleLock('contact_persons')"
                  >
                  @if (unlockUserRole['contact_persons']) {
                    <span>
                      <i class="fa-solid fa-lock-open mr-2"></i>{{t('common.lock')}}
                    </span>
                  }
                  @if (!unlockUserRole['contact_persons']) {
                    <span>
                      <i class="fa-solid fa-lock mr-2"></i>{{t('common.unlock')}}
                    </span>
                  }
                </button>
              }
            </p>
            <p>{{ t('hubs.contact_person_role_description') }}</p>
            <div class="mt-3">
              <div class="contributors">
                @for (contact_person of hub.contact_persons; track contact_person) {
                  <span>
                    <multisite-avatar-pill
                      (selected)="removeRoleHolder('contact_persons', contact_person.email)"
                      [cursorNone]="!unlockUserRole['managers']"
                      [removalMode]="unlockUserRole['contact_persons']"
                      [fallbackImageUrl]="'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'" [fallbackTranslationKey]="'social.verified_user'"
                      [imageUrl]="contact_person | userAvatar"
                      [text]="(contact_person.pre_honorific ? contact_person.pre_honorific + ' ' : '') + contact_person.fname +' ' +contact_person.lname + (contact_person.post_honorific ? ' ' + contact_person.post_honorific : '')"
                    ></multisite-avatar-pill>
                  </span>
                }
                <button (click)="toggleNewRoleHolderForm('contact_persons')" class="btn btn-pill"
                  [disabled]="loadingRoleUpdate">
                  <div class="icon">
                    <i class="fa-solid fa-plus"></i>
                  </div>
                  {{
                  showNewRoleForm.contact_persons
                  ? t('common.cancel')
                  : t('common.new')
                  }}
                </button>
              </div>
            </div>
            @if (showNewRoleForm.contact_persons) {
<multisite-email-input-form [labelTextTranslationKey]="
          'common.enter_person_email_address'
          " (emailSubmitted)="addRoleHolder('contact_persons', $event)" [errorTranslationKey]="error"
                [loading]="loadingRoleUpdate" ngClass="w-100">
              </multisite-email-input-form>
            }
            @if (error && unlockUserRole['contact_persons']) {
              <alert [type]="'warning'" [dismissible]="true">
                <span *transloco="let t">{{ t(error) }}</span>
              </alert>
            }
          </div>
          <!-- End of CONTACT PERSON -->
          <!-- HUB TRAINERS -->
          @if (isAdmin()) {
            <div class="editable-row">
              <p class="title">
                {{
                hub.hub_trainers?.length === 1
                ? t('common.hub_trainer')
                : t('common.hub_trainers')
                }}
                @if (hub?.contact_persons.length) {
                  <button class="btn btn-sm btn-primary primary-dark" (click)="toggleRoleLock('hub_trainers')"
                    >
                    @if (unlockUserRole['hub_trainers']) {
                      <span>
                        <i class="fa-solid fa-lock-open mr-2"></i>{{t('common.lock')}}
                      </span>
                    }
                    @if (!unlockUserRole['hub_trainers']) {
                      <span>
                        <i class="fa-solid fa-lock mr-2"></i>{{t('common.unlock')}}
                      </span>
                    }
                  </button>
                }
              </p>
              <p>{{ t('hubs.hub_trainer_role_description') }}</p>
              <div class="contributors" class="mt-3">
                @for (hub_trainer of hub.hub_trainers; track hub_trainer) {
                  <span>
                    <multisite-avatar-pill
                      (selected)="removeRoleHolder('hub_trainers', hub_trainer.email)"
                      [removalMode]="unlockUserRole['hub_trainers']"
                      [fallbackImageUrl]="'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'"
                      [fallbackTranslationKey]="'social.verified_user'"
                      [cursorNone]="!unlockUserRole['hub_trainers']"
                      [imageUrl]="hub_trainer | userAvatar"
                  [text]="
                    hub_trainer.pre_honorific ? hub_trainer.pre_honorific + ' ' : '' +
                    hub_trainer.fname +
                    ' ' +
                    hub_trainer.lname +
                    (hub_trainer.post_honorific ? ' ' + hub_trainer.post_honorific : '')
                  "></multisite-avatar-pill>
                  </span>
                }
                <button (click)="toggleNewRoleHolderForm('hub_trainers')" class="btn btn-pill" [disabled]="loadingRoleUpdate">
                  <div class="icon">
                    <i class="fa-solid fa-plus"></i>
                  </div>
                  {{
                  showNewRoleForm.hub_trainers
                  ? t('common.cancel')
                  : t('common.new')
                  }}
                </button>
              </div>
              @if (showNewRoleForm.hub_trainers) {
<multisite-email-input-form [labelTextTranslationKey]="
              'common.enter_person_email_address'
            " (emailSubmitted)="addRoleHolder('hub_trainers', $event)" [errorTranslationKey]="error"
                  [loading]="loadingRoleUpdate" ngClass="w-100">
                </multisite-email-input-form>
              }
              @if (error && unlockUserRole['hub_trainers']) {
                <alert [type]="'warning'" [dismissible]="true">
                  <span *transloco="let t">{{ t(error) }}</span>
                </alert>
              }
            </div>
          }
          <!-- End of HUB TRAINERS -->
          <!-- Event and programme trainers -->
          @if (isAdmin()) {
            <div class="editable-row">
              <h3 class="title">
                {{
                hub.event_and_programme_trainers?.length === 1
                ? t('hubs.event_and_programme_trainer')
                : t('hubs.event_and_programme_trainers')
                }}
              </h3>
              <p>{{ t('hubs.event_and_programme_trainer_role_description') }}</p>
              @if (unlockUserRole['event_and_programme_trainers']) {
                <p class="text-warning">{{
                t('hubs.event_and_programme_trainer_management_removal_instruction') }}</p>
              }
              <p>{{ t('hubs.event_and_programme_trainer_management_adding_instruction') }}</p>
              @if (hub?.event_and_programme_trainers?.length) {
                <button class="btn btn-sm btn-primary primary-dark" (click)="toggleRoleLock('event_and_programme_trainers')"
                  >
                  @if (unlockUserRole['event_and_programme_trainers']) {
                    <span>
                      <i class="fa-solid fa-lock-open mr-2"></i>{{t('common.lock')}}
                    </span>
                  }
                  @if (!unlockUserRole['event_and_programme_trainers']) {
                    <span>
                      <i class="fa-solid fa-lock mr-2"></i>{{t('common.unlock')}}
                    </span>
                  }
                </button>
              }
              <div class="contributors">
                @for (event_and_programme_trainer of hub.event_and_programme_trainers; track event_and_programme_trainer) {
                  <span
                    [ngClass]="{ disabled: !unlockUserRole['event_and_programme_trainers'] }">
                    <multisite-avatar-pill
                      (selected)="removeRoleHolder('event_and_programme_trainers', event_and_programme_trainer.email)"
                      [removalMode]="unlockUserRole['event_and_programme_trainers']"
                      [fallbackImageUrl]="'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'"
                      [fallbackTranslationKey]="'social.verified_user'"
                      [cursorNone]="!unlockUserRole['event_and_programme_trainers']"
                      [imageUrl]="event_and_programme_trainer | userAvatar"
                [text]="
                    event_and_programme_trainer.pre_honorific +
                    ' ' +
                    event_and_programme_trainer.fname +
                    ' ' +
                    event_and_programme_trainer.lname +
                    ' ' +
                    event_and_programme_trainer.post_honorific
                  "></multisite-avatar-pill>
                  </span>
                }
              </div>
              @if (error && unlockUserRole['event_and_programme_trainers']) {
                <alert [type]="'warning'" [dismissible]="true">
                  <span *transloco="let t">{{ t(error) }}</span>
                </alert>
              }
            </div>
          }
          <!-- End of event and programme trainers -->
          <!-- Hub client trainers -->
          @if (isAdmin()) {
            <div class="editable-row">
              <h3 class="title">
                {{
                hub.hub_client_trainers?.length === 1
                ? t('hubs.hub_client_trainer')
                : t('hubs.hub_client_trainers')
                }}
              </h3>
              <p>{{ t('hubs.hub_client_trainer_role_description') }}</p>
              @if (unlockUserRole['hub_client_trainers']) {
                <p class="text-warning">{{
                t('hubs.hub_client_trainer_management_removal_instruction') }}</p>
              }
              <p>{{ t('hubs.hub_client_trainer_management_adding_instruction') }}</p>
              @if (hub?.hub_client_trainers?.length) {
                <button class="btn btn-sm btn-primary primary-dark" (click)="toggleRoleLock('hub_client_trainers')"
                  >
                  @if (unlockUserRole['hub_client_trainers']) {
                    <span>
                      <i class="fa-solid fa-lock-open mr-2"></i>{{t('common.lock')}}
                    </span>
                  }
                  @if (!unlockUserRole['hub_client_trainers']) {
                    <span>
                      <i class="fa-solid fa-lock mr-2"></i>{{t('common.unlock')}}
                    </span>
                  }
                </button>
              }
              <div class="contributors">
                @for (hub_client_trainer of hub.hub_client_trainers; track hub_client_trainer) {
                  <span>
                    <multisite-avatar-pill (selected)="removeRoleHolder('hub_client_trainers', hub_client_trainer.email)"
                      [removalMode]="unlockUserRole['hub_client_trainers']"
                      [fallbackImageUrl]="'https://res.cloudinary.com/cebt/image/upload/w_24,h_24/v1616972586/users/avatars/default-avatar.gif'"
                      [fallbackTranslationKey]="'social.verified_user'"
                      [cursorNone]="!unlockUserRole['hub_client_trainers']"
                      [imageUrl]="hub_client_trainer | userAvatar"
                [text]="
                    hub_client_trainer.pre_honorific ? hub_client_trainer.pre_honorific + ' ' : '' +
                    hub_client_trainer.fname +
                    ' ' +
                    hub_client_trainer.lname +
                    (hub_client_trainer.post_honorific ? ' ' + hub_client_trainer.post_honorific : '')
                  "></multisite-avatar-pill>
                  </span>
                }
              </div>
              @if (error && unlockUserRole['hub_client_trainers']) {
                <alert [type]="'warning'" [dismissible]="true">
                  <span *transloco="let t">{{ t(error) }}</span>
                </alert>
              }
            </div>
          }
          <!-- End of Hub client trainers -->
        </div>
        <div class="col-lg-4">
          <div class="flex-column align-items-center justify-content-center w-100 h-100">
            @for (link of links; track link) {
              <multisite-link-type-six
                [imageTransformations]="'w_100,c_thumb/'"
                [titleText]="link.label"
                [description]="link.description"
                [image]="link.image"
                [cta_label]="link.cta_label"
                [cta_type]="link.cta_type"
                [url]="link.url"
                >
              </multisite-link-type-six>
            }
          </div>
        </div>
      </div>
      @if (!loading && !hub) {
        <p>{{ t('common.not_found') }}</p>
      }
    </div>
  }
</div>